/**
 * Local-dev environment for the CRM internal app.
 *
 * Points at the deployed dev backend; the Socket.IO `/internal`
 * namespace rides the same host. To run fully local instead, swap
 * `apiBaseUrl`/`realtimeUrl` to `http://localhost:3000/...`.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.expressboattransport.com.au/api/v1',
  realtimeUrl: 'https://api-dev.expressboattransport.com.au/internal',
  appName: 'EBT CRM (dev)',
};
